import React,  { useEffect } from "react";
import Helmet from "react-helmet";
import Carousel from "react-bootstrap/Carousel";
import Footer from "./footer"
import {Link} from "react-router-dom"
import Header from "./header";
import {useSelector,useDispatch} from "react-redux"
import {get,getImage,gethistory} from '../state/action'
function Home() {
  const  gem  = useSelector((state) =>state.gemstone.gemStone);
  const  images  = useSelector((state) =>state.gemstone.images);
  const  history  = useSelector((state) =>  state.gemstone.history);
const dispatch = useDispatch();
console.log(gem)
useEffect(() => {
  dispatch(get());
  dispatch(getImage());
  dispatch(gethistory());
}, []);
  return (
    <div>
     
     <Header/>
      <section className="banner">
       
            <Carousel fade nextLabel="" prevLabel="">
            {images.map((i)=>{
           return(
            <Carousel.Item>
              <img
                style={{height:"500px", width:"100px"}}       
                className="d-block w-100"
                src={i.image}
                alt="First slide"
              />
              
            </Carousel.Item>
                )
              })}
            </Carousel>
       
      </section>

      <section className="feature-section bg-color-1 centred">
        <div className="auto-container">
          <div className="row clearfix">
            {history.map((i)=>{
              return(
        <div className="col-lg-4 col-md-6 col-sm-12 feature-block">
              <div className="feature-block-one">
                <div className="inner-box">
                
                  <h2>
                    {i.name}
                   <br />
                   
                  </h2>
                  <figure className="image-box">
                  <img src={i.image} style={{width:"250px",height:"150px"}} />
                  <Link to={`/history/${i.id}`}>
                  <Link to="#" className="theme-btn-one">
                      Read more
                    </Link>
                </Link>
                   <br></br>
                  </figure>
                </div>
              </div><br></br>
            </div>
              )
            })}
            
            
            
          </div>
        </div>
      </section>
      <section class="cta-section" style={{background:"black"}}>
            <div class="auto-container">
                <div class="inner-box clearfix">
                    <div class="text pull-left">
                        <h2>Gems In Modern History</h2>
                    </div>
                    <div class="btn-box pull-right">
                      <Link to="/history/5" class="theme-btn-one">
                      Discover More
                      </Link>
                    </div>
                </div>
            </div>
        </section>
       <section className="service-section sec-pad bg-color-1">
  <div className="auto-container">
    <div className="sec-title centred">
      <p>Our All Services List</p>
      <h2>Outsourced  Services</h2>
    </div>
    <div className="row clearfix">
      {gem.map((i)=>{
return(
  <div className="col-lg-4 col-md-6 col-sm-12 service-block">
  <div className="service-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="2500ms">
    <div className="inner-box">
      <figure className="image-box">
        <img style={{width:"900px",height:"200px"}} src={i.image} alt />
        <Link to={`/gemdetail/${i.id}`}>
           
            <span className="category">{i.name}</span>
             
          </Link>
      </figure>
    </div><br></br>
  </div>
</div>
)
      })}
    
      {/* <div className="col-lg-3 col-md-6 col-sm-12 service-block">
        <div className="service-block-one wow fadeInUp animated animated" data-wow-delay="300ms" data-wow-duration="1500ms">
          <div className="inner-box">
            <figure className="image-box">
              <img style={{width:"300px",height:"200px"}} src="https://images.unsplash.com/photo-1550852826-5369a2d5e585?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTA2fHxnZW1zdG9uZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60" alt />
              <Link to="/gemdetail">
              <span className="category">OPEL</span>
               </Link>
           
            </figure>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-12 service-block">
        <div className="service-block-one wow fadeInUp animated animated" data-wow-delay="600ms" data-wow-duration="1500ms">
          <div className="inner-box">
            <figure className="image-box">
              <img style={{width:"300px",height:"200px"}} src="https://images.unsplash.com/photo-1589674536249-62d7ea50d6e1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1471&q=80" alt />
              <Link to="/gemdetail">
              <span className="category">RUBY</span>
               </Link>
            </figure>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-12 service-block">
        <div className="service-block-one wow fadeInUp animated animated" data-wow-delay="600ms" data-wow-duration="1500ms">
          <div className="inner-box">
            <figure className="image-box">
              <img style={{width:"300px",height:"200px"}} src="https://images.unsplash.com/photo-1613843351058-1dd06fda7c02?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1548&q=80" alt />
              <Link to="/gemdetail">
              <span className="category">SAPPHIRE</span>
               </Link>
            </figure>
          </div>
        </div>
      </div> */}
    </div>
  </div>
</section>



   <Footer/>
  
    </div>
  );
}
export default Home;
